import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, Tab, Tabs } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import { addItem, fetchId, selectId, selectLoading } from "./journeySlice";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  formatDate,
  CallApi,
  formatDateTime,
  formatterVisit,
  formatterVisitStatus,
  formatCurrency,
  formatQuantity,
  formatterStatus,
  formatterType,
  getLabel,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useHistory, useParams } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useLoadScript,
  Polyline,
  InfoWindow,
} from "@react-google-maps/api";
import { NavLink } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaAngleDown,
  FaAngleRight,
  FaAngleUp,
} from "react-icons/fa";
import { ViewMapsMarker } from "../../utility/ViewMapsMarker";
import { Hidden } from "@material-ui/core";
import { env } from "../../../env";
import { ImageViewer } from "../../utility/ImageViewer";
const { SearchBar } = Search;

export const JourneyEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const { id } = useParams();

  const [tableData, setTableData] = useState([]);
  const [tableDataStock, setTableDataStock] = useState([]);
  const [tableAdjustments, setTableAdjustments] = useState([]);
  const [points, setPoints] = useState([]);
  const [pointsVisit, setPointsVisit] = useState([]);
  const [show, setShow] = useState(false);
  const [showMapVisit, setShowMapVisit] = useState(false);

  const libraries = ["places"];
  const mapContainerStyle = { width: "100%", height: "600px" };
  const center = { lat: -6.2088, lng: 106.8456 };
  const [selected, setSelected] = useState(null);
  const [userPosition, setUserPosition] = useState(null);
  const [positionCustomer1, setPositionCustomer1] = useState(null);

  useEffect(() => {
    async function fetchMyAPI() {
      getUserPosition();

      const params = {
        journey_id: id,
        is_web: true,
      };
      if (id !== undefined) {
        await CallApi(params, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch, id]);

  useEffect(() => {
    if (dataId) {
      // Add number
      const initData = dataId.visits.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          status_distance:
            item.status_distance === null ? "NO RANGE" : item.status_distance,
          checkin_distance:
            item.checkin_distance === null ? "-" : item.checkin_distance,
        };
      });

      setTableData(initData);

      const initPoints = dataId.visits.map((item) => {
        return {
          ...item,
          id: item.visit_id,
          lat:
            item.visit_status_name === "All"
              ? parseFloat(item.visit_latitude)
              : parseFloat(item.latitude),
          lng:
            item.visit_status_name === "Visited"
              ? parseFloat(item.visit_longitude)
              : parseFloat(item.longitude),
        };
      });
      console.log(initPoints, "initPoints");

      setPositionCustomer1({
        lat: parseFloat(initPoints?.[0]?.lat),
        lng: parseFloat(initPoints?.[0]?.lng),
      });

      setPoints(initPoints);

      const initStock = dataId.stocks.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });

      setTableDataStock(initStock);

      const initAdjustments = dataId.adjustments.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });

      setTableAdjustments(initAdjustments);
    }
  }, [dataId]);

  const getUserPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setUserPosition(userPos);
          // Menyesuaikan pusat peta dengan posisi pengguna
          // mapRef.current.panTo(userPos);
        },
        (error) => {
          console.error("Error getting user position:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };
  // maps
  const [segments, setSegments] = useState([]);
  const [totalVisitedDistance, setTotalVisitedDistance] = useState(0);
  const [totalAllDistance, setTotalAllDistance] = useState(0); // <- total semua jarak

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });

  useEffect(() => {
    if (!isLoaded) return;

    const data = points;

    const fetchDirections = async () => {
      try {
        const directionsService = new window.google.maps.DirectionsService();
        const maxWaypoints = 25;
        const totalChunks = Math.ceil((data.length - 2) / maxWaypoints);
        const allSegments = [];

        let visitedDistance = 0; // total jarak visited
        let allDistance = 0; // total semua jarak

        for (let i = 0; i < totalChunks; i++) {
          const start = i * maxWaypoints;
          const end = start + maxWaypoints;

          const chunk = data.slice(start, end + 1);
          if (chunk.length < 2) break;

          const result = await directionsService.route({
            origin: { lat: chunk[0].lat, lng: chunk[0].lng },
            destination: {
              lat: chunk[chunk.length - 1].lat,
              lng: chunk[chunk.length - 1].lng,
            },
            waypoints: chunk.slice(1, chunk.length - 1).map((point) => ({
              location: { lat: point.lat, lng: point.lng },
              stopover: true,
            })),
            travelMode: window.google.maps.TravelMode.DRIVING,
          });

          if (result.status === window.google.maps.DirectionsStatus.OK) {
            processDirections(result, chunk, allSegments, (vDist, aDist) => {
              visitedDistance += vDist;
              allDistance += aDist;
            });
          } else {
            console.error(`Error fetching directions: ${result.status}`);
          }
        }

        setSegments(allSegments);
        setTotalVisitedDistance(visitedDistance);
        setTotalAllDistance(allDistance);
      } catch (err) {
        console.error(`Error: ${err.message}`);
      }
    };

    const processDirections = (result, chunk, allSegments, addDistances) => {
      const route = result.routes[0].legs;

      const getColor = (status) =>
        status === "Visited" ? "#379634" : "#6993FF";

      route.forEach((leg, legIndex) => {
        const nextPointStatus =
          chunk[legIndex + 1]?.visit_status_name || chunk[0].visit_status_name;

        let vDist = 0;
        let aDist = leg.distance.value; // semua jarak selalu ditambahkan

        if (nextPointStatus === "Visited") {
          vDist = leg.distance.value; // visited distance
        }

        addDistances(vDist, aDist);

        leg.steps.forEach((step) => {
          const segmentColor = getColor(nextPointStatus);
          allSegments.push({
            path: step.path,
            color: segmentColor,
          });
        });
      });
    };

    fetchDirections();
  }, [isLoaded, points]);

  console.log(totalVisitedDistance, "totalVisitedDistance");
  console.log(totalAllDistance, "totalAllDistance");

  // Contoh tampilan:
  {
    /* 
  <div>Total Jarak Visited: {(totalVisitedDistance / 1000).toFixed(2)} km</div>
  <div>Total Jarak Semua: {(totalAllDistance / 1000).toFixed(2)} km</div>
*/
  }

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Maps...</div>;
  }

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const handleCloseMapVisit = () => {
    setShow(false);
  };

  const actionFormatter = (e, row) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View Visit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            onClick={() => {
              setPointsVisit([
                {
                  id: "1",
                  lat: row.latitude,
                  lng: row.longitude,
                  label: "Store",
                  store: row.customer_store_name,
                  address: row.customer_address,
                  visit_date: formatDateTime(row.visit_actual_date),
                },
                {
                  id: "2",
                  lat: row.visit_latitude,
                  lng: row.visit_longitude,
                  label: "Visit",
                  store: "",
                  address: "",
                  visit_date: formatDateTime(row.visit_actual_date),
                },
              ]);

              setShowMapVisit(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-secondary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Map/Marker1.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "customer",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
          >
            <NavLink
              className="menu-link"
              to={`/master/customer/edit/${row.customer_id}`}
            >
              {row.customer_code}
              <br />
              <span className="menu-link">{row.customer_store_name}</span>
            </NavLink>
            <br />
          </span>
        );
      },
    },
    {
      text: "store name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
      hidden: true,
    },
    {
      text: "group",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "Status ",
      dataField: "visit_status_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex flex-column">
            <NavLink
              className="menu-link"
              to={`/transaction/journey/visit/${row.visit_id}`}
            >
              <span>{formatterVisit(row.visit_status_name)}</span>
            </NavLink>
            <span className="mt-1">
              {formatDateTime(row.visit_actual_date)}
            </span>
          </div>
        );
      },
    },
    {
      text: "remark pending",
      dataField: "remarks_pending",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "type",
      dataField: "customer_payment_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "130px" },
      formatter: formatterType,
    },
    {
      text: "category",
      dataField: "visit_category",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "120px" },
    },
    {
      text: "status distance",
      dataField: "status_distance",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },
      formatter: formatterStatus,
      formatter: (cell, row) => {
        return (
          <div>
            <b style={{ marginRight: "8px" }}>
              {formatterStatus(row.status_distance)}
            </b>
            <span className="text-right"> | {row.checkin_distance} M</span>
          </div>
        );
      },
    },

    {
      text: "payment cash",
      dataField: "payment_cash",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "payment transfer",
      dataField: "payment_transfer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "payment total",
      dataField: "payment_total",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },

    {
      text: "Action",
      dataField: "action",
      formatter: actionFormatter,
      align: "center",
    },
  ];
  const columnsStock = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "80px",
        position: "sticky",
        left: 0,
        zIndex: 2,
        backgroundColor: "white",
      },
      headerStyle: {
        minWidth: "80px",
        position: "sticky",
        left: 0,
        zIndex: 3,
        backgroundColor: "white",
      },
    },
    {
      text: "product",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "180px",
        position: "sticky",
        left: "60px",
        zIndex: 2,
        backgroundColor: "white",
      },
      headerStyle: {
        minWidth: "180px",
        position: "sticky",
        left: "60px",
        zIndex: 3,
        backgroundColor: "white",
      },

      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <NavLink
                className="menu-link"
                to={`/master/product/edit/${row.product_id}`}
              >
                <b> {row.product_code}</b>
                <br />
                <span>{row.product_name}</span>
              </NavLink>
            </span>
          </div>
        );
      },
    },
    {
      text: "initial stock",
      dataField: "stock_awal",
      style: {
        minWidth: "150px",
        position: "sticky",
        left: "230px",
        zIndex: 2,
        backgroundColor: "white",
      },
      headerStyle: {
        minWidth: "180px",
        position: "sticky",
        left: "240px",
        zIndex: 3,
        backgroundColor: "white",
      },
      align: "right",
    },
    {
      text: "stock in",
      dataField: "stock_in",
      style: { minWidth: "180px" },
      align: "right",
      headerFormatter: (column) => (
        <>
          <Row className="combine-col-header justify-content-center">
            Adjustment
          </Row>
          <div
            style={{ borderBottom: "1px solid #dee2e6", marginBottom: "5px" }}
          ></div>
          <Row gutter={0} align="middle">
            <Col span={11}>In</Col>
            <Col>
              <div
                style={{
                  height: "20px", // Adjust height as needed
                  borderLeft: "1px solid #dee2e6", // Vertical line
                  margin: "0 10px", // Add some space around the line
                }}
              ></div>
            </Col>
            <Col span={11}>Out</Col>
          </Row>
        </>
      ),
      formatter: (cell, row) => (
        <Row gutter={24}>
          {" "}
          <Col span={12}>{cell} </Col> <Col span={12}>{row.stock_out}</Col>{" "}
        </Row>
      ),
    },

    {
      text: "order",
      dataField: "ordered_qty",
      style: { minWidth: "120px" },
      align: "right",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "returned ok",
      dataField: "returned_ok_qty",
      style: { minWidth: "280px" },
      align: "right",
      headerFormatter: (column) => (
        <>
          <Row className="combine-col-header justify-content-center">
            Returned
          </Row>
          <div
            style={{ borderBottom: "1px solid #dee2e6", marginBottom: "5px" }}
          ></div>
          <Row
            gutter={0}
            align="middle"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Col span={8} style={{ textAlign: "center" }}>
              OK
            </Col>
            <div
              style={{
                height: "20px", // Adjust height as needed
                borderLeft: "1px solid #dee2e6", // Vertical line
                margin: "0 10px", // Add some space around the line
              }}
            ></div>
            <Col span={8} style={{ textAlign: "center" }}>
              DMG
            </Col>
            <div
              style={{
                height: "20px", // Adjust height as needed
                borderLeft: "1px solid #dee2e6", // Vertical line
                margin: "0 10px", // Add some space around the line
              }}
            ></div>
            <Col span={8} style={{ textAlign: "center" }}>
              EXP
            </Col>
          </Row>
        </>
      ),

      formatter: (cell, row) => (
        <Row gutter={24}>
          {" "}
          <Col span={12}>{cell} </Col>{" "}
          <Col span={12}>{row.returned_dmg_qty}</Col>{" "}
          <Col span={12}>{row.returned_exp_qty}</Col>{" "}
        </Row>
      ),
    },
    {
      text: "final stock",
      dataField: "stock_akhir",
      style: { minWidth: "140px" },
      align: "right",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];
  const centerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  };

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    // expanded: [0, 1],
    renderer: (row) => (
      <BootstrapTable
        keyField="adjustment_detail_id"
        data={row.details === null ? [] : row.details}
        columns={columnsDetail}
      />
    ),
    expandColumnRenderer: ({ expanded }) =>
      expanded ? <FaAngleUp /> : <FaAngleDown />,
    expandHeaderColumnRenderer: ({ isAnyExpands }) =>
      isAnyExpands ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />,
    align: "center",
  };
  const columnsAdjustments = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "adjustment no",
      dataField: "adjustment_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "adjustment date",
      dataField: "adjustment_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      formatter: formatDateTime,
    },

    {
      text: "created by",
      dataField: "created_by",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
  ];
  const columnsDetail = [
    {
      text: "product",
      dataField: "product_code",
      style: { minWidth: "120px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <NavLink
                className="menu-link"
                to={`/master/product/edit/${row.product_id}`}
              >
                <b> {row.product_code}</b>
                <br />
                <span>{row.product_name}</span>
              </NavLink>
            </span>
          </div>
        );
      },
    },
    {
      text: "initial stock",
      dataField: "initial_stock",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "stock in",
      dataField: "stock_in",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "stock out",
      dataField: "stock_out",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "stock final",
      dataField: "stock_final",
      style: { minWidth: "120px" },
      formatter: formatQuantity,
      align: "right",
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Detail Journey">
          <CardHeaderToolbar>
            <Button
              variant="light"
              className="mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button className="btn btn-danger" onClick={handleShow}>
              View Maps
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      readOnly
                      value={dataId?.user?.name_username}
                      onClick={() => {
                        if (dataId?.user?.user_id) {
                          window.open(
                            `/administration/user/edit/${dataId.user.user_id}`,
                            "_blank"
                          );
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#f3f6f9",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Payment Cash</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(dataId?.total_payment_cash)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Payment Transfer</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(dataId?.total_payment_transfer)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Payment Total</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(
                        parseFloat(dataId?.total_payment_transfer) +
                          parseFloat(dataId?.total_payment_cash)
                      )}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Actual Call</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatQuantity(dataId?.call?.actual_call)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Effective Call</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatQuantity(dataId?.call?.effective_call)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Start Image</b>
                  </Form.Label>
                  <Col sm={6}>
                    <div className="col-auto small-image">
                      <ImageViewer url={dataId?.start_image} />
                    </div>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.start_remarks}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>End Image</b>
                  </Form.Label>
                  <Col sm={6}>
                    <div className="col-auto small-image">
                      <ImageViewer url={dataId?.end_image} />
                    </div>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.end_remarks}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status</b>
                  </Form.Label>
                  <Col sm={6}>
                    <span>{formatterStatus(dataId?.status)}</span>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Created By</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={
                        dataId?.created_by && dataId?.created_at
                          ? `${dataId.created_by} - ${formatDateTime(
                              dataId.created_at
                            )}`
                          : ""
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Journey Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={
                        dataId?.journey_date && formatDate(dataId.journey_date)
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Submit Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={
                        dataId?.submit_at && formatDateTime(dataId.submit_at)
                      }
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Revenue</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatCurrency(dataId?.revenue)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Target Call</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatQuantity(dataId?.call?.target_call)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Pending Call</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      className="text-right"
                      disabled
                      value={formatQuantity(dataId?.call?.pending_call)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <Tabs
            defaultActiveKey="List Visit"
            id="uncontrolled-tab-example"
            className="mb-5"
          >
            <Tab eventKey="List Visit" title="List Visit">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableData}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Stock" title="Stock">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableDataStock}
                  columns={columnsStock}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col>
                          <Form.Group as={Row}>
                            <Form.Label column sm={3}>
                              <b>Stock Date</b>
                            </Form.Label>
                            <Col sm={4}>
                              <Form.Control
                                type="text"
                                className="text-right"
                                disabled
                                value={formatDate(
                                  tableDataStock[0]?.stock_date_from
                                )}
                              />
                            </Col>
                            <Col sm={1}>
                              <p className="mt-3">To</p>
                            </Col>
                            <Col sm={4}>
                              <Form.Control
                                type="text"
                                className="text-right"
                                disabled
                                value={formatDate(
                                  tableDataStock[0]?.stock_date_to
                                )}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom "
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
            <Tab eventKey="Adjustments" title="History Adjustments">
              <div
                className="card-body pt-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <ToolkitProvider
                  keyField="no"
                  data={tableAdjustments}
                  columns={columnsAdjustments}
                  search
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col></Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container">
                        <BootstrapTable
                          striped
                          noDataIndication="Data Not Found"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                          expandRow={expandRow}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </Tab>
          </Tabs>
        </CardBody>
      </Card>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Maps |
            <span style={{ color: "green", marginLeft: "10px" }}>
              Visited: {(totalVisitedDistance / 1000).toFixed(2)} km
            </span>
            {" | "}
            <span style={{ color: "blue", marginLeft: "10px" }}>
              Total: {(totalAllDistance / 1000).toFixed(2)} km
            </span>
          </Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          {isLoaded ? (
            <GoogleMap
              id="autocomplete-demo"
              mapContainerStyle={mapContainerStyle}
              zoom={14}
              center={userPosition === null ? positionCustomer1 : userPosition}
            >
              {/* {directions && (
                <DirectionsRenderer
                  directions={directions}
                  options={{ polylineOptions: { strokeColor: "transparent" } }}
                />
              )} */}
              {segments.map((segment, index) => (
                <Polyline
                  key={index}
                  path={segment.path}
                  options={{ strokeColor: segment.color, strokeWeight: 4 }}
                />
              ))}
              {points.map((position, index) => (
                <Marker
                  key={position.id}
                  position={{ lat: position.lat, lng: position.lng }}
                  label={getLabel(index)} // Menambahkan label sesuai indeks
                  onClick={() => setSelected(position)}
                />
              ))}
              {selected && (
                <InfoWindow
                  position={{ lat: selected.lat, lng: selected.lng }}
                  onCloseClick={() => setSelected(null)}
                >
                  <div>
                    <h2>{selected.customer_store_name}</h2>
                    <p>{selected.customer_address}</p>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
          ) : (
            <div>Loading...</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ViewMapsMarker
        points={pointsVisit}
        setPoints={setPointsVisit}
        show={showMapVisit}
        setShow={setShowMapVisit}
      />
    </>
  );
};
